<template>
	<div class="col-12 col-lg-12">
		<div

			class="form-group"
			:class="{
				'form-group--error': isValidate === false,
				'form-group--success': isValidate === true,
			}"
			:state="isValidate"
		>
			<label class="d-block col-form-label-sm">{{ field.name }}</label>

			<client-only>
				<vue-dadata
					:ref="`dadataCity_${personNumber}`"
					:query="value"
					:token="dadataToken"
					default-class="input-city-dadata"
					placeholder=""
					input-name="bank"
					url="https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/bank"
				/>
			</client-only>

			<div v-if="isValidate === false" class="error">
				Пожалуйста, укажите банк, попробуйте ввести БИК или SWIFT
			</div>
			<!-- 111 </b-form-group> -->
		</div>
	</div>
</template>

<script>
import VueDadata from 'vue-dadata';
import {
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_FORM_FIELDS_DATA,
} from '@/store/checkout';

export default {
	name: 'Bank',
	components: {
		VueDadata,
	},
	props: {
		field: {
			type: Object,
			default: () => {},
		},
		personNumber: {
			type: Number,
			default: 1,
		},
		formData: {
			type: Object,
			default: () => {},
		},
		value: { default: null },
		group: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			dadataToken: process.env.dadataApiKey,
			isValidate: null,
		};
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$refs[`dadataCity_${this.personNumber}`]) {
				this.$refs[
					`dadataCity_${this.personNumber}`
				].onInputBlur = this.onChangeBank; // ГРЯЗНЫЙ ХАК
			}
		});
	},
	methods: {
		async onChangeBank() {
			if (!this.$refs[`dadataCity_${this.personNumber}`]) {
				return;
			}

			const suggestions = await this.$refs[`dadataCity_${this.personNumber}`].fetchSuggestions();
			if (!Array.isArray(suggestions)) {
				this.isValidate = false;
				return;
			}

			this.isValidate = true;
			this.$refs[`dadataCity_${this.personNumber}`].inputFocused = false;

			const { value } = suggestions[0];
			const { data } = suggestions[0];
			const fields = {};

			let fieldsOnCurrentSteps = this.formData.fields[this.field.step];
			if (this.group) {
				fieldsOnCurrentSteps = this.formData.fields[this.field.step][this.group].children;
			}

			const pushField = (k, v) => {
				const fieldOnCurrentStep = fieldsOnCurrentSteps[k];
				if (!fieldOnCurrentStep) return;

				fields[k] = {
					value: v,
					personNumber: this.personNumber,
					formFieldId: fieldOnCurrentStep.form_field_id,
				};
			};

			pushField(this.field.slug, value);

			for (const field in data) {
				const fieldName = `bank_${field}`;

				if (typeof data[field] === 'string' || typeof data[field] === 'boolean' || typeof data[field] === 'number') {
					pushField(fieldName, data[field]);
					continue;
				}
				try {
					for (const innerField in data[field]) {
						if (typeof data[field][innerField] === 'string'
							|| typeof data[field][innerField] === 'boolean'
							|| typeof data[field][innerField] === 'number'
						) {
							pushField(`${fieldName}_${innerField}`, data[field][innerField]);
						}
					}
				} catch (e) {
					this.$logger.log(e);
				}
			}

			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_FIELDS_DATA}`,
				{
					fields: {
						[this.personNumber]: fields,
					},
					formId: this.formData.id,
				},
			);

			this.$emit('change');
			this.$emit('blur', value, null, true);
		},
		/**
		 * Проверяем валидность по библиотеке vuelidate
		 * @param form Oбъект, сгенерированный vuelidate, содержит инфу об ошибках
		 */
		checkValidation(form) {
			this.isValidate = typeof form[this.field.slug]?.$error !== 'undefined' ? !form[this.field.slug]?.$error : true;
			return this.isValidate;
		},
	},
};
</script>

<style lang="scss">
	@import "assets/styles/sk_variables";
	// For use bootstrap vars and mixins inside
	@import "assets/styles/bootstrap/scss/functions";
	@import "assets/styles/bootstrap/scss/variables";
	@import "assets/styles/bootstrap/scss/mixins";

	.input-city-dadata {
		&__container {
			width: 100%;
			position: relative;
		}

		&__input {
			// Styles copied from bootstrap/_forms.scss (.form-control class)

			display: block;
			width: 100%;
			height: $input-height;
			padding: $input-padding-y $input-padding-x;
			font-family: $input-font-family;
			@include font-size($input-font-size);
			font-weight: $input-font-weight;
			line-height: $input-line-height;
			color: $input-color;
			background-color: $input-bg;
			background-clip: padding-box;
			border: $input-border-width solid $input-border-color;
			border-width: 0 0 1px 0;

			// Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.
			@include border-radius($input-border-radius, 0);

			@include box-shadow($input-box-shadow);
			@include transition($input-transition);

			// Unstyle the caret on `<select>`s in IE10+.
			&::-ms-expand {
				background-color: transparent;
				border: 0;
			}

			// Remove select outline from select box in FF
			&:-moz-focusring {
				color: transparent;
				text-shadow: 0 0 0 $input-color;
			}

			// Customize the `:focus` state to imitate native WebKit styles.
			@include form-control-focus($ignore-warning: true);

			// Placeholder
			&::placeholder {
				color: $input-placeholder-color;
				// Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.
				opacity: 1;
			}

			// Disabled and read-only inputs
			//
			// HTML5 says that controls under a fieldset > legend:first-child won't be
			// disabled if the fieldset is disabled. Due to implementation difficulty, we
			// don't honor that edge case; we style them as disabled anyway.
			&:disabled,
			&[readonly] {
				background-color: $input-disabled-bg;
				// iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.
				opacity: 1;
			}

		}

		&__suggestions {
			position: absolute;
			z-index: 10;
			width: 100%;
			display: flex;
			flex-direction: column;
			background-color: #fff;

			&-item {
				padding: 10px;
				cursor: pointer;
				transition: 0.3s;

				&-highlight {
					background-color: #455fed;
					color: #fff;
				}

				&:hover {
					background-color: #455fed;
					color: #fff;
				}

				&_current {
					background-color: #455fed;
					color: #fff;
				}
			}
		}
	}

	.error {
		width: 100%;
		margin-top: 0.25rem;
		font-size: 80%;
		color: #dc3545;
	}
</style>
